/**
 * Function to test if the incoming parameter is truthy and not an empty object.
 * @param item The item to test on.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function isTruthyAndNotEmpty<T>(item: T | {}): item is NonNullable<T> {
  return !!item && Object.keys(item).length > 0
}
